<template>
    <tr class="cart-table__row">
        <td class="cart-table__column cart-table__column--image-kit">
            <div class="image image--type--product">
                <a href="#" class="image__body">
                    <img class="image__tag" :src="optional_item.image" alt="">
                </a>
            </div>
        </td>
        <td class="cart-table__column cart-table__column--quantity" data-title="Quantity">
                <!-- <div class="cart-table__quantity input-number">
                <input class="form-control-order-entry-qty-selector input-number__input" type="number" min="0" value="1" data-title="Quantity">
                <div class="input-number__add"></div>
                <div class="input-number__sub"></div>
                </div> -->
            <!-- <base-quantity-input v-model="quantity"></base-quantity-input> -->
            <div class="cart-table__quantity input-number">
                <input 
                    class="form-control-order-entry-qty-selector input-number__input" 
                    type="number" 
                    min="1" 
                    :value="quantity"
                    @change="changedQty($event.target.value)"
                />
                <div class="input-number__add" @click="startChange('add')" ></div>
                <div class="input-number__sub" @click="startChange('sub')" ></div>
            </div>
        </td>

        <td class="cart-table__column cart-table__column--product">
            <a href="#" class="cart-table__product-name">{{optional_item.desc}}</a>
            <div class="text-cart-item-number"><font class="text-cart-item-number">Item: {{optional_item.item}}</font></div>
            <div class="text-cart-item-number" v-if="optional_item.info == 'SUBSTITUTE'">
                <span class="text-cart-item-number-alternate-added">ALTERNATE for Item: {{optional_item.origItem}}</span>
                <a href="javascript:void(0)" class="block-brands__item-alternates-available mt-0 mb-1" @click="removeAlternate">(REMOVE ALTERNATE)</a>
            </div>
            <div class="text-cart-item-manufacturer"><font class="text-cart-item-manufacturer">Manufacturer: {{optional_item.manufacturername}}</font></div>
            <div class="block-brands__item-alternates-available"></div>
        </td>
        <td class="cart-table__column cart-table__column--kit-size" data-title="Size">
            <select id="component-size" name="component-size" v-model="size_sel" class="form-control form-control-kit-size" v-if="optional_item.sizes.length > 0">
                <option value="" data-select2-id="57">Size</option> 
                <option v-for="(size, index) in sizes" 
                :key="index"
                :value="size.QSIZE">
                    {{size.QSIZEITM}}
                </option>
            </select>
        </td>
        <td class="cart-table__column cart-table__column--numeral" data-title="Availabilty">
            <div class="block-brands__kit-item-required-qty"></div>
            <div class="block-brands__kit-item-stock-on-hand-zero" v-if="optional_item.stockquantity <= 0">{{optional_item.stockquantity}}</div>
            <div class="block-brands__kit-item-stock-on-hand" v-else>{{optional_item.stockquantity}}</div>
            <div class="block-brands__item-alternates-available" v-if="optional_item.alternatives.length > 0">
                <a href="#myModal" id="myBtn" class="block-brands__item-alternates-available" @click.prevent="viewAlternative()"> View Alternates</a>
            </div>
        </td>
        <td class="cart-table__column cart-table__column--price" data-title="Price">
            <p class="cart-table--price"><strong>{{toUSD(optional_item.yourprice)}}</strong>
                <br/>
                <!-- <span v-if="userIsAuthenticated == true && customerIndicator == 'B'">List Price: {{toUSD(optional_item.listprice)}}</span> -->
            </p>
        </td>
        <td class="cart-table__column cart-table__column--total" data-title="Total">
            <strong>{{toUSD(linetotal)}}</strong>
        </td>
        <td class="cart-table__column cart-table__column--remove">
            <!-- <svg width="25" height="25" viewBox="0 0 32 32" class="cart-X-svg cart-table__remove"><path d="M25.313 9.229l-7.438 7.438 7.438 7.438-1.875 1.875-7.438-7.438-7.438 7.438-1.875-1.875 7.438-7.438-7.438-7.438 1.875-1.875 7.438 7.438 7.438-7.438z"></path></svg> -->
        </td>
    </tr>
</template>

<script>
import MXPrice from '../../../mixins/price';
import { mapGetters } from 'vuex';

export default {
    mixins: [MXPrice],
    data() {
        return {
            quantity: 0,
            size_sel: '',
        }
    },
    props: {
        optional_item: {
            type: Object,
            required: true,
        },
        sizes: {
            type: Array
        },
        hasAlternative: {
            type: Number
        }
    },
    watch: {
        quantity(newVal){
            this.$emit('changed_qty', this.optional_item, newVal);
        }
    },

    ...mapGetters([
            'userIsAuthenticated',
            'customerIndicator'
        ]),

    methods:{
        changedQty(val){
            this.quantity = val;
            // this.qty_perkit = val;
            // this.$emit('changed_qty', this.kit_product, val);
        },
        startChange(form) {
            let qty = this.quantity;
            if (!isNaN(parseInt(this.quantity))) {
                qty = parseInt(this.quantity)
            }
            if (form === 'add') {
                qty += 1;
            } else {
                qty = (qty - 1 < 0) ? qty = 0 : qty - 1;
            }
            this.quantity = qty;
            // this.qty_perkit = qty;

            // this.$emit('changed_qty', this.kit_product, qty);
        },

        viewAlternative() {
            this.$emit('view-alternative', this.optional_item, this.size_sel);
        },

        /**
         * remove alternate
         * */
         removeAlternate() {
            this.$emit('remove-alternatives', this.optional_item);
        },
    },
    computed: {
        linetotal(){
            const ltotal = this.quantity * this.optional_item.yourprice;
            return ltotal;
        }
    },
    created(){
        // console.log('optional item');
        // console.log(this.optional_item);
    }
}
</script>